export const DEFAULT_INPUT_DATE_TIME_FORMAT = 'MM/dd/yyyy HH:mm';
export const DEFAULT_INPUT_DATE_FORMAT = 'MM/dd/yyyy';
